
import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import NewsLayout from '../../components/feature/NewsLayout';

interface Article {
  id: string;
  title: string;
  content: string;
  category: string;
  excerpt: string;
  image_url: string;
  author: string;
  published_at: string;
  tags: string[];
  view_count: number;
}

export default function TarotPage() {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTarotArticles();
  }, []);

  const fetchTarotArticles = async () => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/get-articles?category=塔羅占卜&limit=50`,
        {
          headers: {
            'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY}`,
          },
        }
      );
      
      if (response.ok) {
        const data = await response.json();
        const articlesWithImages = (data.articles || []).map((article: Article) => ({
          ...article,
          image_url: article.image_url || getTarotFallbackImage()
        }));
        setArticles(articlesWithImages);
      }
    } catch (error) {
      console.error('獲取塔羅文章失敗:', error);
      setArticles(getDefaultTarotArticles());
    } finally {
      setLoading(false);
    }
  };

  const getTarotFallbackImage = () => {
    const timestamp = Date.now();
    return `https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=250&fit=crop&crop=center&auto=format&q=80&t=${timestamp}`;
  };

  const getDefaultTarotArticles = () => [
    {
      id: 'tarot1',
      title: '塔羅牌愛情占卜：你的真愛何時到來？',
      excerpt: '透過塔羅牌的神秘力量，探索你的愛情運勢，了解真愛降臨的時機與徵兆，為你的感情生活指引方向...',
      published_at: '2024-01-15T10:30:00Z',
      category: '塔羅占卜',
      image_url: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=250&fit=crop&crop=center&auto=format&q=80',
      author: '塔羅大師 Luna',
      content: '塔羅牌愛情占卜是一門古老而神秘的藝術，它能夠幫助我們洞察愛情的奧秘，預見未來的感情走向。在這個充滿變化的時代，許多人都渴望找到屬於自己的真愛，而塔羅牌正是一個很好的指引工具。\n\n愛情塔羅占卜通常會使用特定的牌陣，如三張牌愛情牌陣、凱爾特十字牌陣等。每一張牌都代表著不同的含義和訊息，通過解讀這些牌的組合，我們可以了解到愛情的現狀、未來的發展趨勢，以及需要注意的事項。\n\n在進行愛情塔羅占卜時，最重要的是保持開放的心態和誠實的態度。塔羅牌並不是預言未來的絕對工具，而是一面鏡子，反映出我們內心深處的想法和感受。通過塔羅牌的指引，我們可以更好地了解自己，從而在愛情的道路上做出更明智的選擇。',
      tags: ['塔羅', '愛情', '占卜'],
      view_count: 1256
    },
    {
      id: 'tarot2',
      title: '大阿爾克那牌義解析：愚者的旅程完整指南',
      excerpt: '從愚者到世界，22張大阿爾克那牌描繪了人生的完整旅程，每一張牌都蕴含著深刻的智慧與人生啟示...',
      published_at: '2024-01-14T15:45:00Z',
      category: '塔羅占卜',
      image_url: 'https://images.unsplash.com/photo-1551269901-5c5e14c25df7?w=400&h=250&fit=crop&crop=center&auto=format&q=80',
      author: '塔羅大師 Luna',
      content: '大阿爾克那是塔羅牌中最重要的部分，由22張牌組成，代表著人生的重大課題和靈性成長的旅程。這個旅程從愚者開始，到世界結束，象徵著一個完整的生命週期。\n\n愚者代表著新的開始、純真和無限的可能性。當愚者出現在占卜中時，通常意味著你正站在人生的新起點上，準備踏上一段全新的旅程。這張牌鼓勵我們保持開放的心態，勇敢地面對未知的挑戰。\n\n隨著旅程的進行，愚者會遇到各種不同的人物和情境，每一張牌都代表著人生中的重要課題。魔術師教導我們如何運用自己的能力，女祭司引導我們傾聽內在的聲音，皇帝和皇后則代表著權威和母性的力量。\n\n通過學習大阿爾克那的牌義，我們可以更好地理解人生的各個階段，並從中獲得智慧和指引。',
      tags: ['塔羅', '大阿爾克那', '牌義'],
      view_count: 2103
    },
    {
      id: 'tarot3',
      title: '塔羅牌事業運勢指南：職場成功的神秘密碼',
      excerpt: '運用塔羅牌的智慧指引，為你的事業發展提供方向，找到職場成功的關鍵要素，開啟事業新篇章...',
      published_at: '2024-01-13T09:20:00Z',
      category: '塔羅占卜',
      image_url: 'https://images.unsplash.com/photo-1540569014015-19a7be504e3a?w=400&h=250&fit=crop&crop=center&auto=format&q=80',
      author: '塔羅大師 Luna',
      content: '在現代社會中，事業成功是許多人追求的目標。塔羅牌作為一種古老的占卜工具，不僅可以幫助我們了解愛情運勢，也能為事業發展提供寶貴的指引。\n\n事業塔羅占卜通常會關注以下幾個方面：當前的工作狀況、未來的發展機會、潛在的挑戰和障礙，以及如何克服困難達成目標。通過塔羅牌的指引，我們可以更清楚地看到自己的優勢和劣勢，從而制定更有效的職業規劃。\n\n在進行事業塔羅占卜時，常用的牌陣包括三張牌事業牌陣、職業發展牌陣等。每一張牌都會提供不同的訊息和建議，幫助我們在職場中做出更明智的決策。\n\n記住，塔羅牌只是一個工具，真正的成功還需要我們的努力和行動。通過塔羅牌的指引，結合自己的實際情況，相信每個人都能在事業上取得成功。',
      tags: ['塔羅', '事業', '職場'],
      view_count: 1789
    },
    {
      id: 'tarot4',
      title: '月亮牌深度解析：直覺與潛意識的覺醒',
      excerpt: '月亮牌代表著直覺、夢境和潛意識的力量，學會解讀這張牌的深層含義，開啟內在智慧之門...',
      published_at: '2024-01-12T14:15:00Z',
      category: '塔羅占卜',
      image_url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=250&fit=crop&crop=center&auto=format&q=80',
      author: '塔羅大師 Luna',
      content: '月亮牌是大阿爾克那中最神秘和複雜的牌之一，它代表著直覺、幻象、潛意識和內在的恐懼。當月亮牌出現在占卜中時，通常意味著我們正處在一個充滿不確定性的時期，需要依靠直覺來指引方向。\n\n月亮牌的圖像通常描繪著一輪明月高掛在夜空中，下方有兩隻狼或狗在嚎叫，還有一隻龍蝦從水中爬出。這些象徵都有著深刻的含義：月亮代表著潛意識和直覺，狼和狗象徵著野性和馴化的本能，而龍蝦則代表著從潛意識深處浮現的想法和感受。\n\n當月亮牌出現時，它提醒我們要相信自己的直覺，同時也要小心幻象和欺騙。這張牌鼓勵我們深入探索自己的內心世界，面對那些被壓抑的恐懼和慾望。\n\n通過理解月亮牌的含義，我們可以更好地處理生活中的不確定性，學會在黑暗中尋找光明。',
      tags: ['塔羅', '月亮牌', '直覺'],
      view_count: 1456
    },
    {
      id: 'tarot5',
      title: '塔羅牌財運占卜：金錢能量的流動密碼',
      excerpt: '透過塔羅牌解讀財運走勢，了解金錢能量的流動規律，掌握投資理財的最佳時機...',
      published_at: '2024-01-11T11:30:00Z',
      category: '塔羅占卜',
      image_url: 'https://images.unsplash.com/photo-1559526324-593bc073d938?w=400&h=250&fit=crop&crop=center&auto=format&q=80',
      author: '塔羅大師 Luna',
      content: '財運是許多人關心的重要議題，而塔羅牌可以為我們提供關於金錢能量流動的深刻洞察。通過財運塔羅占卜，我們可以了解當前的財務狀況、未來的財運走勢，以及如何改善自己的經濟狀況。\n\n在塔羅牌中，錢幣牌組（五角星牌組）是與財運最直接相關的牌組。這個牌組代表著物質世界、金錢、工作和實際的成就。每一張錢幣牌都有著不同的含義，從錢幣一的新機會到錢幣十的財富累積，描繪了財運發展的完整過程。\n\n進行財運塔羅占卜時，我們通常會關注以下幾個方面：當前的財務狀況、收入來源的穩定性、投資機會的評估、以及潛在的財務風險。通過塔羅牌的指引，我們可以做出更明智的財務決策。\n\n記住，塔羅牌提供的是指引和建議，真正的財富還需要通過實際的行動和努力來創造。',
      tags: ['塔羅', '財運', '金錢'],
      view_count: 1834
    },
    {
      id: 'tarot6',
      title: '塔羅牌每日一抽：今日運勢指引',
      excerpt: '每日塔羅牌抽取，為你的一天提供靈性指引，了解今日的能量流動與注意事項...',
      published_at: '2024-01-10T08:00:00Z',
      category: '塔羅占卜',
      image_url: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400&h=250&fit=crop&crop=center&auto=format&q=80',
      author: '塔羅大師 Luna',
      content: '每日塔羅牌抽取是一個簡單而有效的占卜方式，可以為我們的一天提供靈性指引和能量洞察。通過每天抽取一張塔羅牌，我們可以了解當日的主要能量、需要注意的事項，以及如何更好地度過這一天。\n\n進行每日塔羅牌抽取的方法很簡單：在早晨起床後，靜心冥想片刻，然後從塔羅牌中隨機抽取一張牌。這張牌將成為你今日的指引牌，提供關於當天能量和建議的訊息。\n\n每日塔羅牌的解讀應該結合牌的基本含義和當天的具體情況。例如，如果抽到太陽牌，可能意味著今天是充滿正能量和成功機會的一天；如果抽到寶劍三，則可能提醒你要注意情感上的傷痛或溝通上的問題。\n\n通過堅持每日塔羅牌抽取，我們可以逐漸提高自己的直覺能力，更好地理解塔羅牌的智慧，並在日常生活中應用這些指引。',
      tags: ['塔羅', '每日運勢', '指引'],
      view_count: 987
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <NewsLayout 
        articles={articles}
        loading={loading}
        category="塔羅占卜"
        categoryColor="bg-purple-600"
      />
      <Footer />
    </div>
  );
}
